import { render, staticRenderFns } from "./PrvDirectProduct.vue?vue&type=template&id=5642a498&scoped=true&"
import script from "./PrvDirectProduct.vue?vue&type=script&lang=js&"
export * from "./PrvDirectProduct.vue?vue&type=script&lang=js&"
import style0 from "./PrvDirectProduct.vue?vue&type=style&index=0&id=5642a498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642a498",
  null
  
)

export default component.exports